<script>
export default {
    name: "PixabayInfoText",
    props: {
        images: Array,
        loading: Boolean,
        hasSearched: Boolean,
    },
    computed: {
        translations() {
            return {
                query: Lang.langGet('Enter a query to search for images.'),
                noResults: Lang.langGet('No results.'),
            }
        }
    }
}
</script>

<template>
    <div
        v-if="!hasSearched"
        class="pixabay-info-text"
    >
        {{ translations.query }}
    </div>
    <div
        v-else-if="!loading && !images.length && hasSearched"
        class="pixabay-info-text"
    >
        {{ translations.noResults }}
    </div>
</template>

<style scoped>
.pixabay-info-text {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    font-style: italic;
}
</style>
